const config = {
  ENVIRONMENT_NAME: 'testing',
  forwoodId: {
    URL: 'https://id.testing.platform.forwoodsafety.com',
    USER_TOKEN_URL: 'https://lduzcwfzrd.execute-api.us-west-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://0n5hbgt308.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'teams-container-1.11.7',
    HOSTNAME: 'https://teams.testing.platform.forwoodsafety.com',
    TEAMS_MICROFRONTEND_URL: 'https://teams-service.testing.platform.forwoodsafety.com',
    TARGETS_MICROFRONTEND_URL: 'https://targets.testing.platform.forwoodsafety.com',
    TEAMS_ACCESS_ROLE: 'TeamsAccess',
    TEAM_TARGETS_ACCESS_ROLE: 'TeamTargetsAccess',
  },
  configurationService: {
    URL: 'https://config.testing.platform.forwoodsafety.com',
    WEBSOCKET: 'wss://0bmk6ppdq1.execute-api.us-west-2.amazonaws.com/testing'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
